import { render, staticRenderFns } from "./PromProducts.vue?vue&type=template&id=0b04f130&scoped=true"
import script from "./PromProducts.vue?vue&type=script&lang=js"
export * from "./PromProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b04f130",
  null
  
)

export default component.exports